class ProductPricing {
  constructor() {
    this.sectionId = window.productData?.sectionId;
    if (!this.sectionId) {
      console.warn('Product section ID not found');
      return;
    }

    this.variantRadiosDesktop = document.querySelector(`#variant-radios-${this.sectionId}`);
    this.variantRadiosMobile = document.querySelector(`#variant-radios-mobile-${this.sectionId}`);
    this.shippingPromises = document.querySelectorAll('.shipping-promise div');
    this.is3PLOrder = document.getElementById('is3PLOrder_gas')?.value === 'true';
    
    this.handleQuantityClick = this.handleQuantityClick.bind(this);
    
    this.init();
  }

  init() {
    this.calculateSavings();
    this.initQuantityControls();
    this.updateShippingDisplay();
  
    this.setupEventListeners();
  
    setInterval(() => this.updateShippingDisplay(), 60000);
  }

  setupEventListeners() {
    document.addEventListener('variant:changed', () => {
      requestAnimationFrame(() => this.calculateSavings());
    });
  
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId === this.sectionId) {
        this.calculateSavings();
        this.initQuantityControls();
      }
    });
  }

  handleQuantityClick(e) {
    const quantityButton = e.target.closest('[data-action="increase"], [data-action="decrease"]');
    if (!quantityButton) return;
    
    const wrapper = quantityButton.closest('.quantity-wrapper');
    if (!wrapper) return;
    
    const input = wrapper.querySelector('.quantity-input');
    if (!input) return;
    
    const currentValue = parseInt(input.value, 10);
    
    if (quantityButton.dataset.action === 'increase') {
      input.value = currentValue + 1;
    } else if (quantityButton.dataset.action === 'decrease' && currentValue > 1) {
      input.value = currentValue - 1;
    }
    
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  initQuantityControls() {
    document.removeEventListener('click', this.handleQuantityClick);
    document.addEventListener('click', this.handleQuantityClick);
  }

  calculateSavings() {
    const calculateForElement = (variantRadios) => {
      if (!variantRadios) return;

      const jsonScript = variantRadios.querySelector('script[type="application/json"]');
      if (!jsonScript) return;

      let variants;
      try {
        variants = JSON.parse(jsonScript.textContent);
      } catch (e) {
        console.error('Failed to parse variants JSON:', e);
        return;
      }

      const baseVariant = variants.reduce((smallest, variant) => {
        const quantity = parseInt(variant.title.match(/\d+/)?.[0] || '0');
        return (!smallest || quantity < smallest.quantity) ? { variant, quantity } : smallest;
      }, null);

      if (!baseVariant) return;

      if (baseVariant.variant.compare_at_price != null) {
        variantRadios.querySelectorAll('input[type="radio"]').forEach(radio => {
          const variant = variants.find(v => v.title === radio.value) || 
                         variants.find(v => v.option1 === radio.value);    
          if (!variant) return;

          const savings = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          console.log('Savings: '+savings);

          const label = radio.closest('.product-form__input')?.querySelector(`label[for="${radio.id}"]`);
          if (!label) return;
  
          const existingTag = label.querySelector('.variant-selector__save');
          if (existingTag) {
            existingTag.remove();
          }
          
          if (savings > 0) {
            const savingsTag = document.createElement('span');
            savingsTag.className = 'variant-selector__save';
            savingsTag.textContent = `Save ${savings}%`;
            label.appendChild(savingsTag);
          }
        });        
      }
      else {
        const basePrice = (baseVariant.variant.price / 100) / baseVariant.quantity;
  
        variantRadios.querySelectorAll('input[type="radio"]').forEach(radio => {
          const variant = variants.find(v => v.title === radio.value) || 
                         variants.find(v => v.option1 === radio.value);
          
          if (!variant) return;
  
          const quantity = parseInt(variant.title.match(/\d+/)?.[0] || '0');
          if (!quantity) return;
  
          const pricePerUnit = (variant.price / 100) / quantity;
          const savings = Math.round((1 - (pricePerUnit / basePrice)) * 100);

  console.log('Savings: '+savings);
          const label = radio.closest('.product-form__input')?.querySelector(`label[for="${radio.id}"]`);
          if (!label) return;
  
          const existingTag = label.querySelector('.variant-selector__save');
          if (existingTag) {
            existingTag.remove();
          }
          
          if (savings > 0) {
            const savingsTag = document.createElement('span');
            savingsTag.className = 'variant-selector__save';
            savingsTag.textContent = `Save ${savings}%`;
            label.appendChild(savingsTag);
          }
        });
      }
    };

    calculateForElement(this.variantRadiosDesktop);
    calculateForElement(this.variantRadiosMobile);
  }

  isDST(date) {
    const jan = new Date(date.getFullYear(), 0, 1);
    const jul = new Date(date.getFullYear(), 6, 1);
    return date.getTimezoneOffset() < Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
  }

  // Helper function to check if a date is a holiday
  isHoliday(date, holidays) {
    // Format date as DD-MM-YYYY
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    return holidays.includes(formattedDate);
  }
  
  // Helper function to find the next valid delivery date
  getNextValidDeliveryDate(date, holidays) {
    while (date.getDay() === 0 || date.getDay() === 6 || date.getDay() === 1 || this.isHoliday(date, holidays)) {
      date.setDate(date.getDate() + 1); // Move to the next day
    }
    return date;
  }
  
  calculateShipping() {
    const today = new Date();
    
    let cutoffHour = this.is3PLOrder ? 11 : 14;
    const cutoffMinutes = 0;
    
    if (this.isDST(today)) {
      cutoffHour -= 1;
    }
    
    const cutoffTime = new Date(Date.UTC(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
      cutoffHour,
      cutoffMinutes,
      0
    ));

    let deliveryDate = new Date(today);

    const holidays = ["28-11-2024", "29-11-2024", "30-11-2024", "25-12-2024", "26-12-2024", "01-01-2025", "02-01-2025"];  
    
    if (today.getDay() === 5 && today.getHours() >= cutoffTime.getHours()) {
      deliveryDate.setDate(deliveryDate.getDate() + 4);
    } else if (today.getDay() === 6) {
      deliveryDate.setDate(deliveryDate.getDate() + 3);
    } else if (today.getDay() === 0) {
      deliveryDate.setDate(deliveryDate.getDate() + 2);
    } else {
      if (today.getTime() >= cutoffTime.getTime()) {
        deliveryDate.setDate(deliveryDate.getDate() + 2);
      } else {
        deliveryDate.setDate(deliveryDate.getDate() + 1);
      }
    }
    console.log('Delivery Date Old: '+deliveryDate);

    // Check and adjust for holidays
    deliveryDate = this.getNextValidDeliveryDate(deliveryDate, holidays);

    console.log('Delivery Date New: '+deliveryDate);

    let hoursLeft = cutoffTime.getHours() - today.getHours();
    if (hoursLeft < 0) {
      hoursLeft *= -1;
    }

    if (today.getHours() >= cutoffTime.getHours()) {
      hoursLeft = 23 - hoursLeft;
    } else {
      hoursLeft -= 1;
    }

    const minutesLeft = 60 - today.getMinutes();

    return {
      date: deliveryDate,
      hoursLeft: Math.max(0, hoursLeft),
      minutesLeft: Math.max(0, minutesLeft)
    };
  }

  updateShippingDisplay() {
    const shippingInfo = this.calculateShipping();
    
    this.shippingPromises.forEach(promise => {
      if (promise) {
        promise.innerHTML = `
          <p>Get it as soon as <b>${shippingInfo.date.toLocaleDateString('en-US', { 
            weekday: 'long', 
            month: 'long', 
            day: 'numeric' 
          })}</b> <span class="shipping-promise__separator">|</span> Order within ${shippingInfo.hoursLeft}h ${shippingInfo.minutesLeft}m</p>
        `;
      }
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new ProductPricing());
} else {
  new ProductPricing();
}